import React from 'react';

const PromoSection = () => {
  const promoOffers = [
    {
      title: 'Gratis Instalasi',
      description: 'Instalasi gratis untuk semua paket internet rumah dan bisnis',
      icon: '🔧',
      color: 'from-blue-600 to-cyan-600'
    },
    {
      title: 'Router WiFi 6 Gratis',
      description: 'Dapatkan router WiFi 6 terbaru gratis untuk paket premium',
      icon: '📶',
      color: 'from-green-600 to-emerald-600'
    },
    {
      title: 'Netflix Premium',
      description: 'Berlangganan Netflix Premium gratis 3-6 bulan',
      icon: '📺',
      color: 'from-purple-600 to-indigo-600'
    },
    {
      title: 'Speed Boost',
      description: 'Upgrade kecepatan gratis 2x lipat untuk 3 bulan pertama',
      icon: '🚀',
      color: 'from-orange-600 to-red-600'
    }
  ];

  return (
    <section className="py-16 bg-gray-800">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold mb-4">Penawaran Spesial Internet</h2>
          <p className="text-xl text-gray-400 max-w-2xl mx-auto">
            Dapatkan internet super cepat dengan bonus menarik dan harga terbaik
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {promoOffers.map((offer, index) => (
            <div key={index} className={`promo-card bg-gradient-to-br ${offer.color} rounded-2xl p-6 text-white`}>
              <div className="text-4xl mb-4">{offer.icon}</div>
              <h3 className="text-xl font-bold mb-2">{offer.title}</h3>
              <p className="text-gray-100">{offer.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PromoSection;